/**
 * Shared Status Constants
 * Single source of truth for device and location status across the entire application
 */

export const STATUS = {
  HEALTHY: 'healthy',
  WARNING: 'warning', 
  CRITICAL: 'critical'
};

export const STATUS_UI = {
  [STATUS.HEALTHY]: {
    color: '#34c759',
    icon: '🟢',
    label: 'Healthy',
    priority: 1
  },
  [STATUS.WARNING]: {
    color: '#ff9500', 
    icon: '🟡',
    label: 'Warning',
    priority: 2
  },
  [STATUS.CRITICAL]: {
    color: '#ff3b30',
    icon: '🔴', 
    label: 'Critical',
    priority: 3
  }
};

/**
 * Get the worst status from an array of statuses
 * @param {string[]} statuses - Array of status strings
 * @returns {string} - Worst status by priority
 */
export const getWorstStatus = (statuses) => {
  if (!statuses || statuses.length === 0) return STATUS.CRITICAL;
  
  return statuses.reduce((worst, current) => {
    const currentPriority = STATUS_UI[current]?.priority || 0;
    const worstPriority = STATUS_UI[worst]?.priority || 0;
    return currentPriority > worstPriority ? current : worst;
  }, STATUS.HEALTHY);
};

/**
 * Get UI properties for a given status
 * @param {string} status - Status enum value
 * @returns {object} - UI properties (color, icon, label, priority)
 */
export const getStatusUI = (status) => {
  return STATUS_UI[status] || STATUS_UI[STATUS.CRITICAL];
};

export default {
  STATUS,
  STATUS_UI,
  getWorstStatus,
  getStatusUI
}; 